import { iconMap } from '@sourcepilot/ui/framework/ui/atoms/icons';

interface TagProps {
  label?: string;
  value?: string;
  addButton?: boolean;
}

export function Tag({ label, value = '', addButton = false }: TagProps) {

  const iconStyle = addButton
    ? "h-[11px] w-[11px] mr-[4px] text-[#4d30a0]"
    : "h-[11px] w-[11px] mr-[4px] text-[#4d30a0]";

  const txtStyle = addButton
    ? "border-[#8e71c6] text-[#4d30a0] bg-[white] hover:bg-[#faeaff] font-code leading-normal border-dashed"
    : "border-[#8e71c6] text-[#4d30a0] bg-[white] hover:bg-[#faeaff] font-code leading-normal";

  const text = addButton
    ? 'add'
    : value;

  const get_context_icon = (typeName: string | undefined) => {
    if (!typeName || typeName === '') {
      typeName = addButton ? 'addTag' :'any';
    }
    const Icn: React.ComponentType<any> | undefined = iconMap[typeName];
    if (!Icn) return null;
    return <Icn className={iconStyle} />;
  }

  return (
    <div
      className={`inline-flex items-center border text-center text-[11px] py-[0px] px-[4px] rounded-[2px] ${txtStyle} cursor-pointer`}
    >
        {get_context_icon(label?.toLowerCase())}
        {text}
    </div>
  )
} 